<!-- eslint-disable -->
<template lang="pug">
    drop-down-slider(
        v-if="answers.length || gameStarted"
        :game-started="gameStarted"
        :game-mode="gameMode"
        :items-length="answers.length"
    )
        .link(
            v-for="(item, index) in answers",
            :key='index'
        )
            drag.answers-container__drag(
                v-if="linksType === 'image' && item.type !== 'dropZone'"
                :draggable="gameStarted && item.type !== 'correct-link'"
                :transfer-data="{ item: item, index: index, from: 'answers-box'}"
                @dragstart="$emit('dragStarted')"
                @dragend="$emit('dragEnded')"
            )
                img(
                    class="answer"
                    :class="{ 'answer_correct': item.type === 'correct-link' }",
                    :src='item.value | apiFile',
                    :data-index='index'
                    :draggable="gameStarted && item.type !== 'correct-link'"
                )
</template>

<script>
    /*eslint-disable*/
    import { Drag, Drop } from 'vue-drag-drop';
    import DropDownSlider from "../DropDownSlider.vue";
    const DEFAULT_VOLUME = 0.6;

    export default {
        props: {
            answers: {
                type: Array,
                default: () => {
                    return [];
                }
            },
            gameStarted: Boolean,
            gameMode: String,
            linksType: String,
            dragStarted: Boolean,
            helperModeOn: Boolean,
        },
        data () {
            return {
                showingIndex: 0,
                soundInstance: null,
                isInputFocused: false,
            }
        },
        watch: {
            dragStarted (value) {
                let shakeZone = document.querySelectorAll('.drop-zone__shake-zone');
                let amount = shakeZone.length;
                let timeouts = [];
                if (value && shakeZone) {
                    for (let i = 0; i < amount; i++) {
                        timeouts.push(setTimeout(() => {
                            shakeZone[i].classList.add('shake');
                        }, i * 100));
                    }
                    setTimeout(() => {
                        for(let j = 0; j < timeouts.length; j++) {
                            clearTimeout(timeouts[j]);
                        }
                        for (let i = 0; i < amount; i++) {
                            if (shakeZone[i]) {
                                shakeZone[i].classList.remove('shake');
                            }
                        }
                    }, 2000)
                }
            }
        },
        updated () {
            this.isInputFocused = this.helperModeOn === true ? false : this.isInputFocused;
            if (!this.isInputFocused && this.$refs.input && this.$refs.input[0]) {
                this.$refs.input[0].blur();
                this.focusNextElement();
            }
        },
        methods: {
            handleScrollOfBox (e) {
                e = window.event || e;
                let delta = Math.max(-1, Math.min(1, (e.wheelDelta || -e.detail)));
                let className = '.answers-container';
                document.querySelector(className).scrollLeft -= (delta * 65);
                e.preventDefault();
            },
            focusInput (event) {
                this.isInputFocused = this.$refs.input.some(element => _.isEqual(element, event.target));
            },
            focusNextElement(index = 0) {
                let uncompletedItems = this.answers.filter(item => item.type === "textInput");
                let completedItems = this.answers.filter((item, itemIndex) => item.type !== "textInput" && itemIndex < index);
                index = index - completedItems.length;
                index = index >= uncompletedItems.length ? index % uncompletedItems.length : index;
                let isChainCompleted = !this.answers.some(item => item.value === '');
                if (isChainCompleted) {
                    this.isInputFocused = false;
                    this.$emit('processReply');
                } else if (this.$refs.input[index]) {
                    this.$refs.input[index].focus();
                }
            },
        },
        computed: {
            itemValue () {
                return this.answers[this.showingIndex].value;
            },
        },
        components: {
            Drag,
            Drop,
            DropDownSlider,
        }
    }
</script>

<style lang="scss" scoped>
    .link {
        margin-right: 5px;
        display: inline-flex;
        height: 60px !important;
        width: 60px !important;
        @include media($md) {
            height: 80px !important;
            width: 80px !important;
        }
        @include media($xlg) {
            height: 100px !important;
            width: 100px !important;
        }
        @include media($xxl) {
            height: 120px !important;
            width: 120px !important;
        }
        &:first-child {
            margin-left: 5px;
        }
    }

    .flip-div {
        transform: rotateX(180deg);
    }

    .answers-container__drag {
        max-width: 100%;
        max-height: 100%;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        border-radius: 12px;
        border: 2px solid $hsl-color-gray-96;
        img {
            height: 100%;
            border-radius: 12px;
            padding: 3px;
        }
    }

    @import '@/assets/sass/animations/shake.scss';
</style>
